import type { Scalars } from '@frameio/graphql-client/generated';

/**
 * General use image upload client that can also be mocked and tested
 * @param url The url to fetch
 * @param blob The data blob to include in the fetch body
 * @returns Promise containing the fetch response
 */
export const imageUploadClient = async (
  url: Scalars['URL']['output'],
  blob: Blob
) => {
  const data = new FormData();
  data.append('filetype', blob.type);

  return fetch(url, {
    body: blob,
    headers: {
      'Content-Type': blob.type,
      'x-amz-acl': 'private',
    },
    method: 'put',
  });
};
